import React from 'react';
import {connect} from 'react-redux';
import {
    ActionDescriptorsTenderPublicationPurposes, ActionTenderPublicationPurposeAdd,
    ActionTenderPublicationPurposeDelete,
    ActionTenderPublicationPurposeEdit,
} from "../../../parts/actions";
import ColumnResizer from "react-column-resizer";
import Storege from "../../../storage/storage";
import ToolButtons from "../../../parts/ToolButtons";
import Search from "../../../parts/Search";
import TenderTypesPublicationPurpose from "./TenderPublicationPurposePopup";
import RemoveButton from "../../../parts/removeBtn";
import CommonTab from "../../../parts/CommonTabClass";
import EditBtn from "../../../parts/EditBtn";

class TenderPublicationPurposesDescriptorComponent extends CommonTab {

    orderFields = {
        "Tender Publication Purpose Name" : "tenderpublicationpurposename",
        "Tender Publication Purpose Name Eng": "tenderpublicationpurposenameeng"
    };

    state = {
        tenderPublicationPurpose: {},
        popup: false,
        popupType: undefined,
        rowIndex: -1,
        currentItemIndex: -1,
        order: null
    };

    constructor(props) {
        super(props);
        this.state.tenderPublicationPurpose = props.tenderPublicationPurpose;
    }

    changeState = (name, e, id) => {
        let temp = this.props.tenderPublicationPurpose;
        temp.forEach(function (item) {
            if (item.tenderpublicationpurposeid == id) {
                item[name] = e.value;
            }
        });
        this.setState({
            tenderPublicationPurpose: Object.assign({}, temp)
        });
    };

    changePopupType = (actionType) => {
        this.setState({
            popupType: actionType
        })
    };

    changePopupState = () => {
        let currentPopupState = this.state.popup;
        this.setState(
            {
                popup: !currentPopupState
            }
        )
    };

    addContentType = (object) => {
        ActionTenderPublicationPurposeAdd('', object).then(data => {
            Storege.dispatch({
                type: 'ADD TENDER PUBLICATION PURPOSE',
                item: data
            });
            this.changePopupState();
        });
    };

    editContentType = (object) => {
        ActionTenderPublicationPurposeEdit(object.tenderpublicationpurposeid, object).then(data => {
            Storege.dispatch({
                type: 'UPDATE TENDER PUBLICATION PURPOSE',
                item: data,
                id: data.tenderpublicationpurposeid
            });
            this.changePopupState();
        });
    };

    search = (value) => {
        if (value.length) {
            let filteredArray = this.props.tenderPublicationPurpose.filter(item => {
                return item.tenderpublicationpurposename.toLowerCase().indexOf(value.toLowerCase()) != -1 || item.tenderpublicationpurposenameeng.toLowerCase().indexOf(value.toLowerCase()) != -1;
            });
            this.setState({
                filtered: true,
                filteredItems: filteredArray
            });
        } else {
            this.setState({
                filtered: false
            });
        }
    };

    render() {
        if (!this.props.tenderPublicationPurpose.length) {
            ActionDescriptorsTenderPublicationPurposes();
        }
        let {filtered, filteredItems} = this.state;
        let {tenderPublicationPurpose} = this.props;
        let list = filtered ? filteredItems : tenderPublicationPurpose;
        if (!list) {
            return (
                <div className="overlay-loader">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            );
        }
        this.sortResults(list);
        return (
            <div className="row">
                <div className="col-sm-12">
                    <div>
                        <div className="inline-toolbuttons">
                            <h3>Tender Publication Purposes:</h3>
                            <div className={'tool-bar'}>
                                <ToolButtons
                                    actionType={this.changePopupType}
                                    popupChange={this.changePopupState}
                                    id={this.state.currentItemIndex}
                                />
                                <Search
                                    change={this.search}
                                />
                            </div>
                        </div>
                        <table className='table table-striped'>
                            <thead>
                            {this.orderPanel()}
                            </thead>
                            <tbody>
                            {(list ? list : []).map((item, index) => {
                                return (
                                    <tr key={index} onClick={
                                        e => {
                                            e.preventDefault();
                                            this.setState({
                                                rowIndex: index,
                                                currentItemIndex: item.tenderpublicationpurposeid
                                            });
                                        }
                                    } className={this.state.rowIndex == index ? 'active' : ''}>
                                        <td className={'flex-row'}>
                                            <RemoveButton
                                                action={ActionTenderPublicationPurposeDelete}
                                                id={item.tenderpublicationpurposeid}
                                                descriptor={'REMOVE TENDER PUBLICATION PURPOSE'}
                                            />
                                            <EditBtn
                                                actionType={this.changePopupType}
                                                popupChange={this.changePopupState}
                                                change={this.setCurrentIndex}
                                                id={item.tenderpublicationpurposeid}
                                            />
                                        </td>
                                        <td>{item.tenderpublicationpurposename}</td>
                                        <ColumnResizer className="columnResizer" minWidth={5}/>
                                        <td>{item.tenderpublicationpurposenameeng}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
                {this.state.popup ? <TenderTypesPublicationPurpose
                    close={this.changePopupState}
                    action={this.state.popupType == 'add' ? this.addContentType : this.editContentType}
                    button={this.state.popupType == 'add' ? 'Add' : 'Update'}
                    id={this.state.popupType == 'edit' ? this.state.currentItemIndex : -1}
                /> : ''}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        tenderPublicationPurpose: state.tenderPublicationPurpose
    }
};
const DescriptorTenderPublicationPurposes = connect(mapStateToProps)(TenderPublicationPurposesDescriptorComponent);

export default DescriptorTenderPublicationPurposes;